import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Landing from "@/pages/Landing";
import Editor from "@/pages/Editor";
import PublicWedding from "@/pages/PublicWedding";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

// Minimal 404 fallback so bad or half-baked URLs (e.g. `/w/` with an empty
// slug because the wedding hasn't been published yet) render a friendly
// dead-end instead of a blank white page.
function NotFound() {
    return (
        <div
            data-testid="not-found-root"
            className="h-[100dvh] w-full flex items-center justify-center text-[var(--ink-soft)] px-6"
        >
            <div className="text-center">
                <div className="font-serif text-5xl mb-3">404</div>
                <div className="text-sm mb-6">
                    Esta página no existe o la web aún no ha sido publicada.
                </div>
                <Link to="/" className="btn-primary">
                    Volver al inicio
                </Link>
            </div>
        </div>
    );
}

// AppRouter detects the OAuth callback SYNCHRONOUSLY during render (NOT in
// useEffect) to avoid the race condition where the ProtectedRoute would
// try to check /auth/me before the session_id has been exchanged for a
// session cookie.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH.
function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/editor" element={<Editor />} />
            <Route path="/w/:slug" element={<PublicWedding />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <AppRouter />
            </BrowserRouter>
        </div>
    );
}

export default App;
